import PropTypes from 'prop-types';
import SiteLayout from './SiteLayout';
import TwoColumnLayout from './TwoColumnLayout';

export default function ArticleLayout({
	article,
	children,
	className = null,
	preHeaderContent = null,
	preFooterContent = null,
}) {
	return (
		<SiteLayout>
			<TwoColumnLayout
				article={article}
				className={className}
				preHeaderContent={preHeaderContent}
				preFooterContent={preFooterContent}
			>
				{children}
			</TwoColumnLayout>
		</SiteLayout>
	);
}

ArticleLayout.propTypes = {
	children: PropTypes.shape({}).isRequired,
	article: PropTypes.object.isRequired,
	className: PropTypes.string,
	preHeaderContent: PropTypes.func,
	preFooterContent: PropTypes.func,
};
